// Feature flags — flip to re-enable hidden features.
// vipCampaign: hides the VIP Points sidebar item + /profile/vip-points route,
// the VIP progress card + VIP Level Benefits on My Wallet, and the checkout
// lucky-draw hints. The backend keeps its data; see also AWARD_VIP_POINTS in
// node-3c-ecommerce/src/cron/order_points_awarding.js.
// luckyDrawWinners: the home-page winners banner. Fed by treasure-box physical
// prize wins (GET /customer/lucky-draw/recent-winners) — NOT tied to the VIP
// campaign, so it stays on while vipCampaign is off.
export const FEATURES = {
    vipCampaign: false,
    luckyDrawWinners: true,
}
